import { render } from "./OilTestAssets.vue?vue&type=template&id=77190026"
import script from "./OilTestAssets.vue?vue&type=script&lang=js"
export * from "./OilTestAssets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__